import { render } from "./CargaGrupos.vue?vue&type=template&id=6c248829&scoped=true"
import script from "./CargaGrupos.vue?vue&type=script&lang=js"
export * from "./CargaGrupos.vue?vue&type=script&lang=js"

import "./CargaGrupos.vue?vue&type=style&index=0&id=6c248829&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c248829"]])

export default __exports__